"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = exports.removeCookie = exports.getPPU = exports.getCookie = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var domain = '';
// eslint-disable-next-line no-undef
if (typeof location !== 'undefined' && location.hostname) {
  // eslint-disable-next-line no-undef
  if (location.hostname.indexOf('zhuanzhuan.com') > 0) {
    domain = 'zhuanzhuan.com';
    // eslint-disable-next-line no-undef
  } else if (location.hostname.indexOf('caihuoxia.com') > 0) {
    domain = 'caihuoxia.com';
    // eslint-disable-next-line no-undef
  } else if (location.hostname.indexOf('58.com') > 0) {
    domain = '58.com';
  } else {
    // eslint-disable-next-line no-undef
    domain = location.hostname;
  }
}
var getCookie = function getCookie(name) {
  if (name) {
    return _jsCookie.default.get(name);
  } else {
    var values = document.cookie.split(/;\s+/);
    var result = {};
    if (values && values.length) {
      values.forEach(function (v) {
        var temp = v.split('=');
        if (temp && temp.length === 2) {
          result[temp[0]] = temp[1];
        }
      });
    }
    return result;
  }
};
exports.getCookie = getCookie;
var setCookie = function setCookie() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var expires = opt.expires || new Date().getTime() + 3600 * 24 * 90;
  for (var p in opt) {
    // eslint-disable-next-line no-prototype-builtins
    if (opt.hasOwnProperty(p)) {
      document.cookie = p + '=' + opt[p] + '; domain=' + domain + '; path=/; expires=' + new Date(expires).toUTCString();
    }
  }
};
exports.setCookie = setCookie;
var removeCookie = function removeCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + '; domain=' + domain + '; path=/; expires=' + new Date(exp).toUTCString();
  }
};
exports.removeCookie = removeCookie;
var getPPU = function getPPU() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PPU';
  var reg = /([^&=]+)=?([^&]*)/g;
  var ppuCookie = getCookie(name) || '';
  var ppu = {};
  if (typeof ppuCookie === 'string') {
    for (var regExe = reg.exec(ppuCookie); regExe !== null; regExe = reg.exec(ppuCookie)) {
      ppu[regExe[1]] = regExe[2];
    }
    return ppu;
  }
  return ppu;
};
exports.getPPU = getPPU;